class Form{

    constructor(){


    }
    resetForm(){
        this.clearFields();
        this.restoreForm();
        
        setTimeout(() => {
            this.enableForm();
        }, 3000);
    }
    restoreForm(){
       this.form[0].reset();
    }
    clearFields(){
       this.form.find('input, textarea, button').val('');
    }
    disableForm(){
        this.form.find('input, textarea, button').prop('disabled', true);
    }
    enableForm(){
        this.form.find('input, textarea, button').prop('disabled', false);
    }
    showprocessMessage(){
        this.button.html('<div class="busy-spinner-light"></div>');
    }
    removeprocessMessage(){
        this.button.html('Submit');
    }
}
export default Form;